import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=5afa2d65&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"
import style0 from "./LoginForm.vue?vue&type=style&index=0&id=5afa2d65&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afa2d65",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5afa2d65')) {
      api.createRecord('5afa2d65', component.options)
    } else {
      api.reload('5afa2d65', component.options)
    }
    module.hot.accept("./LoginForm.vue?vue&type=template&id=5afa2d65&scoped=true", function () {
      api.rerender('5afa2d65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/auth/components/LoginForm.vue"
export default component.exports